export default __webpack_public_path__ + "static/media/edit.f9a98551.svg";